module.exports = __webpack_public_path__ + "img/ireland.ec0b8e0e.svg";